import { create } from 'zustand';
import type { FaixaDePreco } from '../@types/IPA/PrecoPsicologico';

interface PrecoPsicologicoState {
  faixaEmEdicao: FaixaDePreco | null;
  modalExclusaoAberto: boolean;
  idSelecionado: string | null;
  faixaSelecionada: FaixaDePreco | null;
  setFaixaEmEdicao: (faixa: FaixaDePreco | null) => void;
  abrirModalExclusao: (faixa: FaixaDePreco) => void;
  fecharModalExclusao: () => void;
}

export const usePrecoPsicologicoStore = create<PrecoPsicologicoState>(set => ({
  faixaEmEdicao: null,
  modalExclusaoAberto: false,
  idSelecionado: null,
  faixaSelecionada: null,
  setFaixaEmEdicao: faixa => set({ faixaEmEdicao: faixa }),
  abrirModalExclusao: faixa =>
    set({ modalExclusaoAberto: true, idSelecionado: faixa.id, faixaSelecionada: faixa }),
  fecharModalExclusao: () =>
    set({ modalExclusaoAberto: false, idSelecionado: null, faixaSelecionada: null }),
}));
